import { Component, computed } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  datepicker,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { IAutomationActionRefreshStockMovesData } from '@kinet-open-network/shared/data-access/model-pbgas';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-refresh-stock-moves-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class RefreshStockMovesActionComponent extends ActionComponent<'refresh-stock-moves'> {
  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([datepicker('fromDate', 'Dátum od').required()]),
  );

  override dataToModel(data: Partial<IAutomationActionRefreshStockMovesData>) {
    return {
      fromDate: data.fromDate ? new Date(data.fromDate) : undefined,
    };
  }
}
